import {
  breakpoints,
  gutter,
  layers,
  media,
  radius,
  spacing,
  Typography,
} from '@lamimed/pantheon';
import styled, { css } from 'styled-components';

import { headerHeightDesktop } from 'components/Header/styles';

import { Wrapper as Notification } from '../Notification/styles';

interface WrapperProps {
  scale: number;
}

export const HeroWrapper = styled.div<WrapperProps>`
  ${({ scale }) => css`
    position: fixed;
    top: 0;
    width: 100%;
    height: auto;
    z-index: ${layers.menu - 1};

    > div {
      border-radius: 0 0 ${radius.medium} ${radius.medium};
    }

    ${media.lessThan('tablet')`
      > div {
        height: ${30 - scale}rem;
        max-height: 30rem;
        min-height: 20rem;
        transition: height 50ms linear;
        will-change: height;
      }

      ${Notification} {
        transition: all ease 0.3s;
        opacity: ${scale ? 0 : 1};
      }


    `}

    ${media.greaterThan('tablet')`
      position: relative;
      margin-bottom: ${spacing.xlarge};
      margin-top: ${headerHeightDesktop};
    `};
  `}
`;

export const BodyWrapper = styled.div`
  ${media.greaterThan('tablet')`
    max-width: ${breakpoints.desktop};
    margin: 0 auto;
  `}
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${spacing.small};

  ${media.greaterThan('tablet')`
    justify-content: flex-start;
  `};
`;

export const DescriptionWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;

  ${media.greaterThan('tablet')`
    margin-bottom: ${spacing.large};
  `}
`;

export const Description = styled(Typography)`
  ${media.greaterThan('tablet')`
    max-width: 30rem;
  `};
`;

export const LinkProxy = styled.a`
  text-decoration: none;
`;

export const IconCloseWrapper = styled.div`
  position: absolute;
  top: 3rem;
  left: ${gutter.default};
`;
